export const OMS_PATH = '/seller-center';
export const BASE_PATH = '';
export const ADVERTISMENT_PATH = `${OMS_PATH}/advertisment`;
export const ORDERS_PATH = `${OMS_PATH}/orders`;
export const FINANCE_PATH = `${OMS_PATH}/finance`;
export const OMS_DASHBOARD_PATH = `${OMS_PATH}/dashboard`;
export const PRODUCT_PATH = `${OMS_PATH}/products`;
export const CHAT_PATH = `${OMS_PATH}/chat`;
export const MARKETING_PATH = `${OMS_PATH}/marketing`;
export const ACCOUNTS_AND_SETTINGS_PATH = `${OMS_PATH}/account-settings`;
export const MANAGE_PRODUCTS = `${PRODUCT_PATH}/manage-products`;
export const ADD_PRODUCT = `${PRODUCT_PATH}/add-product`;
export const EDIT_PRODUCT = `${PRODUCT_PATH}/edit-product/:id`;
export const REVIEWS_PRODUCT = `${PRODUCT_PATH}/reviews`;
export const MANAGE_ORDERS = `${ORDERS_PATH}/manage-orders`;
export const SC_RETURN_ORDERS = `${ORDERS_PATH}/return-orders`;
export const SHIPMENT_ORDERS = `${ORDERS_PATH}/shipments`;
export const ORDER_OVERVIEW_FINANCE = `${FINANCE_PATH}/transaction-history`;
export const ACCOUNT_STATEMENT_FINANCE = `${FINANCE_PATH}/account-statement`;
export const MANAGE_USERS = `${ACCOUNTS_AND_SETTINGS_PATH}/manage-users`;
export const PROFILE_SETTINGS = `${ACCOUNTS_AND_SETTINGS_PATH}/profile-settings`;
export const DELIVERY_SETTINGS = `${ACCOUNTS_AND_SETTINGS_PATH}/delivery-settings`;
export const CATEGORY_COMMISSION = `${ACCOUNTS_AND_SETTINGS_PATH}/category-commission`;
export const TERMS_AND_CONDITIONS = `${OMS_PATH}/terms-and-conditions`;
export const CHAT_SETTINGS = `${ACCOUNTS_AND_SETTINGS_PATH}/chat-settings`;
export const BUY_PACKAGES = `${MARKETING_PATH}/buy-packages`;
export const USAGE_HISTORY = `${MARKETING_PATH}/usage-history`;
export const ORDER_DETAILS = `${ORDERS_PATH}/order-details/:id`;
export const ACCOUNT_STATEMENT_DETAIL = `${ACCOUNT_STATEMENT_FINANCE}/detail/:id`;
export const NOT_FOUND = `${OMS_PATH}/page-not-found`;
export const ACCESS_DENIED = `${OMS_PATH}/access-denied`;
export const SERVER_ERROR = `${OMS_PATH}/unexpected-error`;
export const STORE_NOT_FOUND = `${OMS_PATH}/store-not-found`;
export const LOGIN_PATH = `${OMS_PATH}/login`;
export const SIGNUP_PATH = `${OMS_PATH}/signup`;
export const RESET_PASSWORD_PATH = `${OMS_PATH}/reset-password`;
export const PERFORMANCE_DASHBOARD = `${OMS_PATH}/performance`;
